import { Permission, Res } from 'core/api';
import { SessionProvider } from 'core/infrastructure';
import { Command } from 'pos/common';
import { CashdrawerFacade } from 'pos/facades';
import { Message } from 'core/ui-next/modal';

export default async function extractPendingTipsIfNeeded() {
	const pendingTip = await CashdrawerFacade.getPendingTipToExtract();
	if (pendingTip > 0 && SessionProvider.hasPermission(Permission.Pos_ExtractPendingTip)) {
		const result = await Message.confirm(Res.Msg.MSG_CONFIRM_EXTRACT_TIPS_ON_CLOSE_DAY());
		if (result.ok)
			await Command.execute('extractPendingTip');
	}
}
